import React from 'react';
import PropTypes from 'prop-types';
import {
  SectionDetailLabel,
} from '../styles';
import MonthYearSelector from './month-year-selector';
import Loading from '../../../../../shared/loading';
import { usePostUpdateJoinedCurrentRoleAt } from '../../../../../services/profiles/contributor-settings-service';
import defaultOnErrorHandler from '../../../../../shared/default-on-error-handler';

export default function JoinedCurrentRoleDate({
  organisation, joinedCurrentRoleAt, onUpdate,
}) {
  const [{ loading, error }, post] = usePostUpdateJoinedCurrentRoleAt();
  const loadingRef = React.useRef();

  React.useEffect(() => (loadingRef.current[loading ? 'start' : 'stop']()), [loading]);

  React.useEffect(() => {
    error && defaultOnErrorHandler(error, 'Error saving date of joining current role');
  }, [error]);

  const updateDate = mom => {
    post(mom.format()).then(() => onUpdate({ joinedCurrentRoleAt: mom.format() }));
  };

  return (
    <article>
      <SectionDetailLabel>{`when did you join ${organisation}:`}</SectionDetailLabel>
      <MonthYearSelector value={joinedCurrentRoleAt} onDateSelected={updateDate} />
      <Loading variant="sip" ref={loadingRef} />
    </article>
  );
}

JoinedCurrentRoleDate.propTypes = {
  organisation: PropTypes.string.isRequired,
  joinedCurrentRoleAt: PropTypes.string,
  onUpdate: PropTypes.func,
};

JoinedCurrentRoleDate.defaultProps = {
  joinedCurrentRoleAt: null,
  onUpdate: () => null,
};
